module.exports = __webpack_public_path__ + "img/y_p3_y2.8f3342b0.png";